var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2097 0.947037C21.5306 0.947037 27.4721 6.88862 27.4721 14.2095C27.4721 21.5304 21.5306 27.472 14.2097 27.472C6.88879 27.472 0.947205 21.5304 0.947205 14.2095C0.947205 6.88862 6.88879 0.947037 14.2097 0.947037ZM14.2097 24.5248C19.9081 24.5248 24.5249 19.9079 24.5249 14.2095C24.5249 8.51106 19.9081 3.89425 14.2097 3.89425C8.51123 3.89425 3.89442 8.51106 3.89442 14.2095C3.89442 19.9079 8.51123 24.5248 14.2097 24.5248ZM26.7132 24.6294L30.8821 28.7967L28.7969 30.8819L24.6295 26.7131L26.7132 24.6294Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.9f29fb720e258ded7e49b5ee6aa6b9d2.svg";
export { ForwardRef as ReactComponent };